import { render } from "./PlatformPage.vue?vue&type=template&id=1596d505&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"

import "./PlatformPage.vue?vue&type=style&index=0&id=1596d505&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1596d505"]])

export default __exports__